import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './Home.css'

const Home = () => {
    const [list, setList] = useState([])

    useEffect(() => {
        const url = '/api/ped/getUserPeds'
        const user = { user: localStorage.nomeE }
        axios.post(url, user)
            .then(res => {
                setList(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    return (
        <React.Fragment>
            <div className="labelBuscaPed">
                <i className="bi bi-clipboard iconeBuscaPed"></i>
                MEUS PROCESSOS
            </div>
            <div className="overFlow">
                <div className="buscaPedHeader">
                    <div className="buscaPedElemntHeader">Representante</div>
                    <div className="buscaPedElemntHeader">Representado</div>
                    <div className="buscaPedElemntHeader">Nº Crefito</div>
                    <div className="buscaPedElemntHeader">Nº PAF/PAD</div>
                    <div className="buscaPedElemntHeader">Nº PED</div>
                </div>
                {RenderPeds()}
            </div>
        </React.Fragment>
    )

    function RenderPeds() {
        if (list.length > 0) {
            let tabela = []
            list.map(ped => {
                tabela.push(
                    <div className="buscaPedBody" key={ped.numeroPed}>
                        <a href={`/etica/documentosPed/${ped._id}`}>
                            <div className="buscaPedElemntBody">{ped.representante}</div>
                            <div className="buscaPedElemntBody">{ped.representado}</div>
                            <div className="buscaPedElemntBody">{ped.numeroCrefito}</div>
                            <div className="buscaPedElemntBody">{ped.numeroPaf}</div>
                            <div className="buscaPedElemntBody">{ped.numeroPed}</div>
                        </a>
                    </div>
                )
            })
            return tabela
        }
    }
}

export default Home